/*
 * @Author: 王枫叶
 * @Date: 2020-10-21 14:16:37
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-10-29 20:58:33
 */
import LouFengList from "../views/loufengManagement/louFengList";
import LoufCfg from "../views/loufengManagement/loufCfg";
import Feedback   from "../views/loufengManagement/feedback";
import loufadCfg from "../views/loufengManagement/loufadCfg";
import Main from "../views/main";

const loufRouter={
    path: "/loufeng-list",
    component: Main,
    title: "楼凤管理",
    icon: "el-icon-s-promotion",
    meta: { keepAlive: true },
    children: [
    {
        path: "/loufeng-list",
        component: LouFengList,
        name: "LouFengList",
        title: "楼凤列表",
        meta: { title: "楼凤列表", keepAlive: true },
      },
      {
        path: "/louf-cfg",
        component: LoufCfg,
        name: "LoufCfg",
        title: "城市和折扣配置",
        meta: { title: "城市和折扣配置", keepAlive: true },
      } ,
      {
        path: "/loufad-cfg",
        component: loufadCfg,
        name: "loufadCfg",
        title: "广告配置",
        meta: { title: "广告配置", keepAlive: true },
      } ,      
      {
        path: "/feedback",
        component: Feedback,
        name: "feedback",
        title: "举报信息列表",
        meta: { title: "举报信息列表", keepAlive: true },
      } 
    ]
}
export default loufRouter;